/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import clsx from 'clsx'
import {Dispatch, FC, SetStateAction, useEffect, useRef, useState} from 'react'
import {useIntl} from 'react-intl'
import {Link, useLocation, useNavigate} from 'react-router-dom'
import Joyride, {TooltipRenderProps} from 'react-joyride'

function CustomTooltip(props: TooltipRenderProps) {
  const {backProps, closeProps, continuous, index, primaryProps, skipProps, step, tooltipProps} =
    props

  return (
    <div className='position-relative d-flex flex-column gap-5 align-items-end'>
      <div className='bg-white card shadow-sm rounded min-w-250px' {...tooltipProps}>
        {step.title && (
          <div className='card-header d-flex justify-content-between py-5'>
            <div className='card-title fs-3 fw-bolder text-dark'>{step.title}</div>
          </div>
        )}
        <div className='card-body fs-6 py-5'>{step.content}</div>
        <div className='card-footer d-flex justify-content-between py-5'>
          {index > 0 && (
            <button className='btn btn-sm bg-light me-2' {...backProps}>
              {backProps.title}
            </button>
          )}
          {continuous && (
            <button className='btn btn-sm bg-primary text-white' {...primaryProps}>
              {primaryProps.title}
            </button>
          )}
        </div>
      </div>

      <button className='btn btn-light d-flex align-items-center' {...skipProps}>
        <i className='bi bi-x-lg text-dark'></i>
        {skipProps.title}
      </button>
    </div>
  )
}

type Props = {
  link: string
  setLink: Dispatch<SetStateAction<string>>
}

const AsideTabs: FC<Props> = ({link, setLink}) => {
  const intl = useIntl()
  const navigate = useNavigate()
  const location = useLocation()
  const scrollref = useRef<HTMLDivElement>(null)

  const handleTabClick = (selectedLink: string) => {
    setLink(selectedLink)
    navigate(`/${selectedLink.toLowerCase()}`)
  }

  const workspaceTabs = [
    {
      link: 'members',
      id: 'members',
      icon: 'bi-person',
      tooltip: intl.formatMessage({id: 'MENU.MEMBER'}),
    },
    {
      link: 'Analytics',
      id: 'analytics',
      icon: 'bi-bar-chart-line',
      tooltip: intl.formatMessage({id: 'MENU.ANALYTICS'}),
    },
    {
      link: 'campaign',
      id: 'campaign',
      icon: 'bi-percent',
      tooltip: intl.formatMessage({id: 'MENU.CAMPAIGN'}),
    },
    {
      link: 'VIP',
      id: 'vip',
      icon: 'bi-gem',
      tooltip: intl.formatMessage({id: 'MENU.VIP'}),
    },
    {
      link: 'Referral',
      id: 'referral',
      icon: 'bi-people',
      tooltip: intl.formatMessage({id: 'MENU.REFERRAL'}),
    },
    {
      link: 'Stores',
      id: 'stores',
      icon: 'bi-shop-window',
      tooltip: intl.formatMessage({id: 'MENU.STORE'}),
    },
    {
      link: 'Engagement',
      id: 'engagement',
      icon: 'bi-send',
      tooltip: intl.formatMessage({id: 'MENU.ENGAGEMENT'}),
    },
  ]

  const storeTabs = [
    {
      link: 'Products',
      id: 'products',
      icon: 'bi-box2',
      tooltip: intl.formatMessage({id: 'MENU.PRODUCT'}),
    },
    {
      link: 'Finance',
      id: 'finance',
      icon: 'bi-wallet2',
      tooltip: intl.formatMessage({id: 'MENU.FINANCE'}),
    },
    {
      link: 'E-Store',
      id: 'estore',
      icon: 'bi-shop',
      tooltip: intl.formatMessage({id: 'MENU.ESTORE'}),
    },
    {
      link: 'https://docs.everyvisit.com/',
      id: 'help',
      icon: 'bi-info-circle',
      tooltip: intl.formatMessage({id: 'MENU.HELP'}),
      target: '_blank',
    },
  ]

  /*   const helpTab = {
    link: 'https://docs.everyvisit.com/',
    id: 'help',
    icon: 'bi-info-circle',
    tooltip: intl.formatMessage({id: 'MENU.HELP'}),
    target: '_blank',
  } */

  const allTabs = [...workspaceTabs, ...storeTabs /* helpTab */]
  let activeLink = allTabs.find((t) => location.pathname.includes(t.link.toLowerCase()))
  if (!activeLink) {
    let param = location.search?.split('?')[1]?.split('=')[0]
    if (param && param === 'members') activeLink = allTabs.find((t) => t.link === 'members')
    else if (param && param === 'stores') activeLink = allTabs.find((t) => t.link === 'Stores')
  }

  const renderTab = (t: any) => {
    const isExternal = t.link.startsWith('http')
    const LinkComponent = isExternal ? 'a' : Link
    const linkProps = isExternal
      ? {href: t.link, target: t.target, rel: 'noopener noreferrer'}
      : {to: `/${t.link.toLowerCase()}`}

    return (
      <li key={t.link} className='nav-item py-1'>
        <LinkComponent
          id={t.id}
          {...(linkProps as any)}
          className={clsx(
            'nav-link btn d-flex align-items-center w-100 btn-active-style-none py-2 px-4',
            {active: t === activeLink}
          )}
          onClick={() => !isExternal && handleTabClick(t.link)}
        >
          <span className={'bi ' + t.icon + ' fs-2 me-3'}></span>
          <span className='fs-7 fw-bold'>{t.tooltip}</span>
        </LinkComponent>
      </li>
    )
  }

  return (
    <div className='d-flex flex-column h-100 overflow-hidden'>
      <div className='hover-scroll-y flex-grow-1 pt-8 px-4' ref={scrollref}>
        {/*     <div className='menu-section text-muted fw-bolder fs-9 text-uppercase ps-4 py-4'>
          Workspace
        </div> */}
        <ul className='nav' style={{display: 'block'}}>
          {workspaceTabs.map(renderTab)}
        </ul>
        {/*         <div className='menu-section text-muted fw-bolder fs-9 text-uppercase ps-4 py-4'>Store</div>
         */}{' '}
        <ul className='nav' style={{display: 'block'}}>
          {storeTabs.map(renderTab)}
        </ul>
      </div>

      {/*     <div className='pt-2 px-4 pb-4 mt-auto border-top bg-white'>
        <ul className='nav' style={{display: 'block'}}>
          {renderTab(helpTab)}
        </ul>
      </div> */}
    </div>
  )
}

export {AsideTabs}
